module.exports = __webpack_public_path__ + "static/media/riskAddUp.ad0bebd8.mp3";